import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";
// import RefreshIcon from "../../../../../core/common/tooltip-content/refresh";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import CommonDeleteModal from "../../../../../core/common/modal/commonDeleteModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";

import { Select, Spin, Tag } from "antd";
import { BASE_CRM_URL } from "../../../../components/config/config";

import dayjs from "dayjs";
import Swal from "sweetalert2";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const Proposals = () => {
  const truncateString = (inputString) => {
    if (inputString.length > 25) {
      return inputString.slice(0, 25) + "...";
    }
    return inputString;
  };

  const proposalStatusColors = {
    Sent: "green",
    Pending: "orange",
    Declined: "red",
    Draft: "blue",
    Accepted: "success",
    Default: "default",
  };

  const [proposalStatusOptions, setProposalStatusOptions] = useState([]);

  const getProposalStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposalsStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.ProposalStatus,
        }));

        setProposalStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(proposalStatusOptions, "proposalStatusOptions");

  const columns = [
    {
      title: "#",
      dataIndex: "number",
      sorter: (a, b) => a.number.localeCompare(b.number),
      render: (text, record) => (
        <Link
          to={`/crm/view/proposal`}
          state={{ record }}
          className="text-decoration-none"
        >
          <Tag
            color={
              proposalStatusColors[record.StatusName] ||
              proposalStatusColors.Default
            }
            bordered={false}
            style={{
              borderRadius: 20,
              padding: "4px 12px",
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            {text}
          </Tag>
        </Link>
      ),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      sorter: (a, b) => a.subject.localeCompare(b.subject),

      render: (text, record) => (
        <div className="d-flex align-items-start">
          <div title={text}>
            <Link
              to={`/crm/view/proposal`}
              state={{ record }}
              className="fw-semibold text-dark text-decoration-none"
            >
              {truncateString(text)}
            </Link>
          </div>
        </div>
      ),
    },

    {
      title: "Proposal",
      dataIndex: "proposal_to",
      sorter: (a, b) =>
        (a.proposal_to || "").localeCompare(b.proposal_to || ""),
      render: (_, record) => {
        return (
          <div className="d-flex align-items-start">
            <div className="ms-3" title={record.proposal_to}>
              <i className="fa-regular fa-user text-info me-2"></i>
              {record.proposal_to?.length > 20
                ? `${record.proposal_to.substring(0, 20)}...`
                : record.proposal_to}
            </div>
          </div>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "total",
      sorter: (a, b) => Number(a.total) - Number(b.total),

      render: (amount) => (
        <>
          <div className="fw-semibold">
            <i className="fa-solid fa-indian-rupee-sign text-success me-2"></i>
            {amount}
          </div>
        </>
      ),
    },

    {
      title: "Timeline",
      sorter: (a, b) => new Date(a.open_till) - new Date(b.open_till),
      render: (_, record) => (
        <>
          <div>
            {/* <i className="fa-regular fa-calendar me-2 text-primary"></i> */}
            {dayjs(record.datecreated).format("DD-MM-YYYY") || "-"}
          </div>

          <small className="text-muted text-danger">
            {/* <i className="fa-regular fa-clock me-2"></i> */}
            {dayjs(record.open_till).format("DD-MM-YYYY") || "-"}
          </small>
        </>
      ),
    },

    {
      title: "Project",
      dataIndex: "projectName",
      sorter: (a, b) =>
        (a.projectName || "").localeCompare(b.projectName || ""),
      render: (_, record) => (
        <span title={record.projectName}>
          {record.projectName
            ? record.projectName.length > 10
              ? `${record.projectName.substring(0, 10)}...`
              : record.projectName
            : "N/A"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#6c757d";
            case "Sent":
              return "#0d6efd";
            case "Open":
              return "#0dcaf0";
            case "Revised":
              return "#ffc107";
            case "Declined":
              return "#dc3545";
            case "Accepted":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              proposalStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 100 }}
            options={proposalStatusOptions}
            onChange={(value) => {
              updateProposalStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = proposalStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",

      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                className="dropdown-item"
                to={`/crm/view/proposal`}
                state={{ record }}
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                to={`/crm/update/proposal/${record.id}`}
                className="dropdown-item"
                state={{
                  proposalId: record.id,
                  record,
                }}
              >
                <Edit className="text-secondary me-2" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                to={`/crm/update/proposal/${record.id}`}
                className="me-2 p-2 shadow-sm"
                state={{
                  proposalId: record.id,
                  record,
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [proposalCounts, setProposalCounts] = useState({
    TotalProposals: 0,
    TotalAmount: 0,
    DraftProposals: 0,
    SentProposals: 0,
    AcceptedProposals: 0,
  });

  const [selectedStatus, setSelectedStatus] = useState(0);
  const [proposalList, setProposalList] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [selectedProposalStatus, setSelectedProposalStatus] = useState(0);
  const [exportLoading, setExportLoading] = useState(false);
  console.log(selectedStatus);

  const getProposalCounts = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}proposal/GetProposalCounts`);

      const data = await response.json();

      if (data.Status && data.ResultData.length > 0) {
        setProposalCounts(data.ResultData[0]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getProposalCounts();
    getProposalStatuses();
  }, []);

  const getProposals = async (status = 0) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposals?status=${status}`,
      );

      const data = await response.json();

      if (data.Status) {
        setProposalList(data.ResultData);
      } else {
        setProposalList([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getProposals(0);
  }, []);

  const updateProposalStatus = async (proposalId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/UpdateProposalStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: proposalId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        getProposals();
        getProposalCounts();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const exportExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Proposals");

      // Columns
      worksheet.columns = [
        { header: "Proposal#", key: "number", width: 25 },
        { header: "Company", key: "proposal_to", width: 25 },
        { header: "Project", key: "projectName", width: 32 },
        { header: "Amount", key: "total", width: 18 },
        { header: "Open", key: "open_till", width: 18 },
        { header: "Assigned", key: "AddedByName", width: 18 },
        { header: "Status", key: "StatusName", width: 18 },
      ];

      // Add data
      proposalList.forEach((proposalList) => {
        worksheet.addRow({
          number: proposalList.number ?? "",
          proposal_to: proposalList.proposal_to ?? "",
          projectName: proposalList.projectName ?? "",
          total: proposalList.total ?? "",
          open_till: proposalList.open_till ?? "",
          AddedByName: proposalList.AddedByName ?? "",

          StatusName: proposalList.StatusName || "N/A",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      headerRow.height = 22;

      // Borders and alignment
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Proposal.xlsx");
    } catch (error) {
      console.error("Excel export error:", error);

      Swal.fire("Error", "Failed to generate Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Proposal#",
        "Company",
        "Project",
        "Amount",
        "Open",
        "Assigned",
        "Status",
      ];

      const rows = proposalList.map((proposalList) => [
        proposalList.number ?? "",
        proposalList.proposal_to ?? "",
        proposalList.projectName ?? "",

        proposalList.total ?? "",
        proposalList.open_till ?? "",
        proposalList.AddedByName || "N/A",

        proposalList.StatusName || "N/A",

        // estimate.dateadded
        //   ? new Date(estimate.dateadded).toLocaleString("en-IN")
        //   : "",
      ]);

      // Report title - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Proposal Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 6,
          right: 6,
        },

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        didDrawPage: () => {
          // Footer center
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Total pages
      const totalPages = doc.internal.getNumberOfPages();

      // Page X of Y
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Proposal.pdf");
    } catch (error) {
      console.error("PDF export error:", error);

      Swal.fire("Error", "Failed to generate PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        {exportLoading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div className="content">
          <div className="page-header">
            <div className="add-item">
              <div className="d-flex flex-column">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/crm/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Proposal
                    </h4>
                  </ol>
                </nav>
                <p className="text-muted">Manage your Proposals here</p>
              </div>
            </div>
            <div className="page-btn d-flex jusitfy-content-between">
              <ul className="table-top-head">
                <li>
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <Link onClick={exportPDF}>
                      <ImageWithBasePath
                        src="assets/img/icons/pdf.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
                <li>
                  <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                    <Link
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      onClick={exportExcel}
                    >
                      <ImageWithBasePath
                        src="assets/img/icons/excel.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
              </ul>
              <Link to="/crm/add/proposal" className="btn btn-success btn-sm">
                <i className="ti ti-circle-plus fs-4 "> </i>
              </Link>
            </div>
          </div>

          <div className="row g-3">
            {/* Total */}
            <div
              className="col-12 col-sm-6 col-xl d-flex"
              onClick={() => {
                setSelectedStatus(0);
                getProposals(0);
              }}
            >
              <div
                className={`card flex-fill shadow-sm ${
                  selectedStatus === 0 ? "border-2" : ""
                }`}
                style={{
                  borderColor: selectedStatus === 0 ? "#1B2850" : undefined,
                }}
              >
                <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <h4 className="mb-0 fw-bold">
                      {proposalCounts.TotalProposals}
                    </h4>
                    <p className="mb-0 fw-semibold">Total</p>
                  </div>

                  <div
                    className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{ width: 45, height: 45 }}
                  >
                    <i className="fa-solid fa-file-signature text-primary fs-4"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Accepted */}
            <div
              className="col-12 col-sm-6 col-xl d-flex"
              onClick={() => {
                setSelectedStatus(6);
                getProposals(6);
              }}
            >
              <div
                className={`card flex-fill shadow-sm ${
                  selectedStatus === 6 ? "border-2" : ""
                }`}
                style={{
                  borderColor: selectedStatus === 6 ? "#198754" : undefined,
                }}
              >
                <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <h4 className="mb-0 fw-bold">
                      {proposalCounts.AcceptedProposals}
                    </h4>
                    <p className="mb-0 fw-semibold">Accepted</p>
                  </div>

                  <div
                    className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{ width: 45, height: 45 }}
                  >
                    <i className="fa-solid fa-circle-check text-success fs-4"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Sent */}
            <div
              className="col-12 col-sm-6 col-xl d-flex"
              onClick={() => {
                setSelectedStatus(2);
                getProposals(2);
              }}
            >
              <div
                className={`card flex-fill shadow-sm ${
                  selectedStatus === 2 ? "border-2" : ""
                }`}
                style={{
                  borderColor: selectedStatus === 2 ? "#0dcaf0" : undefined,
                }}
              >
                <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <h4 className="mb-0 fw-bold">
                      {proposalCounts.SentProposals}
                    </h4>
                    <p className="mb-0 fw-semibold">Sent</p>
                  </div>

                  <div
                    className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{ width: 45, height: 45 }}
                  >
                    <i className="fa-solid fa-paper-plane text-info fs-4"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Draft */}
            <div
              className="col-12 col-sm-6 col-xl d-flex"
              onClick={() => {
                setSelectedStatus(1);
                getProposals(1);
              }}
            >
              <div
                className={`card flex-fill shadow-sm ${
                  selectedStatus === 1 ? "border-2" : ""
                }`}
                style={{
                  borderColor: selectedStatus === 1 ? "#ffc107" : undefined,
                }}
              >
                <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                  <div className="d-flex align-items-center gap-2 text-nowrap">
                    <h4 className="mb-0 fw-bold">
                      {proposalCounts.DraftProposals}
                    </h4>
                    <p className="mb-0 fw-semibold">Draft</p>
                  </div>

                  <div
                    className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                    style={{ width: 45, height: 45 }}
                  >
                    <i className="fa-solid fa-clock text-warning fs-4"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* /product list */}
          <div className="card table-list-card ">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set p-3"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Select
                    style={{ width: 150, height: 38 }}
                    placeholder="Filter by Status"
                    value={selectedStatus}
                    onChange={(value) => {
                      setSelectedStatus(value);
                      getProposals(value);
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All",
                      },
                      ...proposalStatusOptions,
                    ]}
                    allowClear={false}
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px", // adjust height if needed
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : (
                  <Table columns={columns} dataSource={proposalList} />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
      <CommonDeleteModal />
    </div>
  );
};

export default Proposals;
